export default __webpack_public_path__ + "assets/fecb300b173dbfe2da04ad807b24f2ea.jpg";